import React from "react";

const PreLoader = () => {
  return (
    <div id='preloader' className='d-block'>
      <div id='status' className='d-block'>
        <div className='spinner-chase'>
          <div className='chase-dot' />
          <div className='chase-dot' />
          <div className='chase-dot' />
          <div className='chase-dot' />
          <div className='chase-dot' />
          <div className='chase-dot' />
        </div>
      </div>
    </div>
  );
};

export default PreLoader;
